/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, CanBeSignals, getProp, $Sprite, $SetVisibility} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';

export type BtnBackgroundProps = CanBeSignals<{
    disabled: boolean;
    pressed: boolean;
}>;

export const $BtnBackground: FC<BtnBackgroundProps> = (props) => {
    const backgroundSelect = Store.computed(() => {
        if (getProp(props.disabled)) {
            return 'disabled';
        }

        if (getProp(props.pressed)) {
            return 'pressed';
        }

        return 'normal';
    });

    return <$SetVisibility selector={backgroundSelect}>
        <$Sprite name='normal' anchor={0.5} texture='spin_empty_normal_sys_ui'/>
        <$Sprite name='pressed' anchor={0.5} texture='spin_empty_pressed_sys_ui'/>
        <$Sprite name='disabled' anchor={0.5} texture='spin_empty_disabled_sys_ui'/>
    </$SetVisibility>;
};